// src/utils/activityFormat.ts
// Liczby z monitoringu aktywności w oknie „Aktywność” na ekranie „Uczniowie” (docs/plan-aktywnosci.md)
import { ActivityTotals } from '../services/ApiService.types';
import i18n from '../i18n';

// Minuty pracy, zaokrąglone; poniżej pół minuty — „<1 min”. Co się liczy — przypis na dole okna
// (student:activity.rules)
export const formatActiveMinutes = (activeSeconds: number): string => (
  activeSeconds < 30
    ? i18n.t('student:activity.underMinute')
    : i18n.t('student:activity.minutes', { n: Math.round(activeSeconds / 60) })
);

// Odsetek poprawnych; bez odpowiedzi z gier, które same sprawdzają odpowiedź — null
export const formatCorrectPercent = ({ checked, correct }: ActivityTotals): string | null => (
  checked > 0 ? `${Math.round((correct / checked) * 100)}%` : null
);
